import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FilterGroupService {
  private url = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getFilterGroup(filter_id: number) {
    return this.http.get(`${this.url}/filter-groups/${filter_id}`);
  }

  searchProfileGroup(params: any) {
    return this.http.get(`${this.url}/filter-groups`, { params });
  }

  updateFilterGroup(filter_id: any, payload: any) {
    return this.http.put(`${this.url}/filter-groups/${filter_id}`, payload);
  }

  createFilterGroup(payload: any) {
    return this.http.post(`${this.url}/filter-groups`, payload);
  }

  deleteFilterGroup(filter_id: any) {
    return this.http.delete(`${this.url}/filter-groups/${filter_id}`);
  }
}
